"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var randomId = function (prefix) {
    return prefix +
        Math.random()
            .toString(36)
            .replace(/[^a-z]+/g, '')
            .substr(2, 10);
};
exports.default = randomId;
//# sourceMappingURL=randomId.js.map